export enum Mode {
  Default = 'splash',
  UpdatePhone = 'updatePhone',
}
